/* eslint-disable jsx-a11y/anchor-is-valid */

const ParameterRocWidget = ({parameterData, setShowMadalLimitROCHistory}) => {
  return (
    <div onClick={() => setShowMadalLimitROCHistory(true)} className={`card hoverable shadow mb-4`}>
      <div className='card-body'>
        <div className={`fw-bold fs-3 mb-1`}>Roc</div>
        <div className={`fw-semibold mt-3`}>
          {parameterData?.roc_status === 'O' ? (
            <span className='badge badge-danger'>Over</span>
          ) : parameterData?.roc_status === 'N' ? (
            <span className='badge badge-success'>Normal</span>
          ) : parameterData?.roc_status === 'U' ? (
            <span className='badge badge-danger'>Under</span>
          ) : (
            <span className='badge badge-secondary'>{parameterData?.roc_status}</span>
          )}
        </div>
        <div className={`fw-semibold mt-3`}>
          Min : {parameterData?.roc_min} , Max : {parameterData?.roc_max}
        </div>
      </div>
    </div>
  )
}

export {ParameterRocWidget}
